/* eslint-disable @atlaskit/design-system/prefer-primitives */
/* @jsx jsx */
import { jsx } from '@emotion/react';
import Button from '@atlaskit/button/standard-button';
import { N0 } from '@atlaskit/theme/colors';
export const AISuggestion = ({
  suggestion,
  onRemove,
  onClick
}) => {
  return jsx("span", {
    style: {
      position: 'relative'
    }
  }, jsx("span", {
    style: {
      position: 'absolute',
      left: 0,
      display: 'flex',
      gap: "var(--ds-space-100, 8px)",
      backgroundColor: `var(--ds-surface, ${N0})`,
      borderRadius: "var(--ds-border-radius-100, 5px)",
      boxShadow: "var(--ds-shadow-overlay, 0 0 1px rgba(9, 30, 66, 0.31), 0 4px 8px -2px rgba(9, 30, 66, 0.25))",
      zIndex: 1
    }
  }, jsx(Button, {
    type: "button",
    spacing: "compact",
    onClick: onClick
  }, suggestion)));
};